import React from 'react';
import {InputSearchFarm} from '../../../assets/styles/GlobalStyles';
import {getStyles} from '../../../utils/getStyles';

export const InputSearch = ({field, form, label, ...props}) => {
    return (
        <>
            <InputSearchFarm
                    style={form ? getStyles(form.errors, field.name) : {}}
                    autoCorrect="off"
                    autoCapitalize="none"
                    autoComplete="off"
                    onChange={(e, value) => {
                        console.log('teste', e, value);
                    }}
                    {...field}
                    {...props}
            />

        </>
    );
};
